import React, { useState, useEffect } from 'react';
import FloatingOptions from '../../ReusableBlocks/FloatingOptions';
import FooterBlock from '../../ReusableBlocks/FooterBlock';
import Marquee from '../../ReusableBlocks/Marquee';
import DC_img from '../../Images/DC-Banner.png';
import { Link, useLocation, useNavigate } from "react-router-dom";
import { pathToRegexp } from 'path-to-regexp';
import { useDispatch, useSelector } from 'react-redux';
import { fetchNarratives } from '../../Redux/Dashboard/External/Home/HomePageContentAction';
import { setTrainingStatus, setTrainingSuccess } from '../../Redux/Dashboard/External/LearningHub/TCTrainingStatusActions';
import { getPartnerDisclaimerAct } from '../../Redux/Dashboard/Components/Disclaimer/GetDisclaimer/GetPartnerDisclaimerAction';
import * as PATH from '../../CentralisedLink';
import { SnackbarProvider } from 'notistack';
import Modal from 'react-bootstrap/Modal';
import Disclaimer from "../../ReusableBlocks/DisclaimerModal";
import EmailMigrationBanner from '../../ReusableBlocks/EmailMigrationBanner';
import { jwtDecode } from 'jwt-decode';
import { checkEmailMigrationStatus } from '../../Redux/Dashboard/External/EmailMigration/EmailMigrationAction';
import { logout } from '../../Redux/Auth/authActions';
import { PENDING_HELIX_EMAIL_KEY } from '../../Constants/emailMigration';
import { useFeatureFlags } from '../../FeatureFlags/FeatureFlagsContext';
import { FEATURE_FLAGS } from '../../FeatureFlags/featureFlagConstants';

const EMAIL_MIGRATION_ROUTES = [
  PATH.UPDATE_EMAIL_PATH,
  PATH.EMAIL_VERIFICATION_SENT_PATH,
  PATH.EMAIL_UPDATED_PATH,
  PATH.EMAIL_VERIFICATION_INVALID_PATH,
  PATH.EMAIL_CHANGE_VERIFY_PATH,
];

const getFirstStringValue = (values) => {
  return values.find((value) => typeof value === 'string' && value.trim()) || '';
};

const getUserEmail = (authState) => {
  const currentUser = authState?.currentUser || {};
  const authUser = authState?.user || {};
  let decodedToken = authState?.decodedToken || {};

  if (!decodedToken.email && authState?.accessToken) {
    try {
      decodedToken = jwtDecode(authState.accessToken) || {};
    } catch (error) {
      decodedToken = authState?.decodedToken || {};
    }
  }

  return getFirstStringValue([
    currentUser.email,
    currentUser.username,
    currentUser.emailAddress,
    currentUser.userEmail,
    currentUser.preferred_username,
    currentUser.upn,
    currentUser.sub,
    authUser.email,
    authUser.username,
    authUser.emailAddress,
    decodedToken.email,
    decodedToken.username,
    decodedToken.emailAddress,
    decodedToken.preferred_username,
    decodedToken.upn,
    decodedToken.sub,
  ]);
};

const PrivateLayout = ({ children, props }) => {



  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { loading, error } = useSelector((state) => state.homePageContent);
  const authState = useSelector(state => state.auth);
  const currentUser = authState?.currentUser;
  const {
    statusLoading,
    migrationCompleted,
    statusError,
  } = useSelector((state) => state.EmailMigration);
  const { isFeatureEnabled } = useFeatureFlags();
  const isEmailMigrationEnabled = isFeatureEnabled(FEATURE_FLAGS.EnableEmailMigration);
  const shouldShowEnablementNav = isFeatureEnabled(FEATURE_FLAGS.EnableEnablement);
  console.log(currentUser?.email)

  

  const { completed, success } = useSelector((state) => state.TCTrainingStatus);

  const [showDCModal, setShowDCModal] = useState(false);
  const [dataFetched, setDataFetched] = useState(false);
  const [errorTimeout, setErrorTimeout] = useState(null);
  const location = useLocation();

  // Checks if route is `/sales/:id`
  const isSalesRoute = /^\/sales\/[^/]+$/.test(location.pathname);
  // Check if the current route is `/home` or `/sales/:id`
  const isHomeOrSalesRoute = location.pathname === "/home" || /^\/sales\/[^/]+$/.test(location.pathname);
  const isChangePasswordRoute = location.pathname === "/changePassword";
  const isEmailMigrationRoute = EMAIL_MIGRATION_ROUTES.some((path) => location.pathname.startsWith(path));


  const excludedPaths = [
    `${PATH.LEARNING_HUB_PATH}`,
    `${PATH.LEARNING_HUB_TRACKS_PATH}:id`,
    `${PATH.LEARNING_HUB_MICROCERTS_PATH}:trackId/:microcertId`,
    `${PATH.LEARNING_HUB_MANDATORY_TRAINING_PATH}:id`,
    `${PATH.PROFILE_PATH}`
  ];

  const matchPath = (pathname, path) => {
    const regexp = pathToRegexp(path);
    return regexp.test(pathname);
  };

  const userEmail = getUserEmail(authState);
  console.log('[EmailMigrationBanner DEBUG] Extracted user email:', userEmail);
  const isBmcUser = userEmail?.toLowerCase().trim().endsWith("@bmc.com");
  const normalizedUserType = String(currentUser?.typeOfUser || '').trim().toLowerCase();
  const isExternalSE = normalizedUserType === 'external se';
  const shouldCheckEmailMigrationStatus =
    isEmailMigrationEnabled &&
    authState?.isAuthenticated &&
    isBmcUser &&
    !isExternalSE &&
    !isEmailMigrationRoute;
  const shouldShowEmailMigrationBanner =
    shouldCheckEmailMigrationStatus &&
    !statusLoading &&
    (migrationCompleted === false || Boolean(statusError));
  const shouldShowEmailAlreadyCompletedBanner =
    shouldCheckEmailMigrationStatus &&
    !statusLoading &&
    migrationCompleted === true;
  console.log('[EmailMigrationBanner DEBUG] isBmcUser evaluation:', isBmcUser);
  console.log('[EmailMigrationBanner DEBUG] isExternalSE evaluation:', isExternalSE);
  console.log('[EmailMigrationBanner DEBUG] will render banner:', shouldShowEmailMigrationBanner);

  const handleEmailMigrationUpdateNow = () => {
    navigate(PATH.UPDATE_EMAIL_PATH);
  };

  const handleEmailMigrationLogoutNow = () => {
    sessionStorage.removeItem(PENDING_HELIX_EMAIL_KEY);
    dispatch(logout());
  };

  useEffect(() => {
    if (
      shouldCheckEmailMigrationStatus &&
      !statusLoading &&
      migrationCompleted === null &&
      !statusError
    ) {
      dispatch(checkEmailMigrationStatus());
    }
  }, [
    dispatch,
    shouldCheckEmailMigrationStatus,
    statusLoading,
    migrationCompleted,
    statusError,
  ]);

  useEffect(() => {
    if (!shouldShowEmailMigrationBanner && !shouldShowEmailAlreadyCompletedBanner) {
      document.body.classList.remove('email-migration-lock-scroll');
      return undefined;
    }

    document.body.classList.add('email-migration-lock-scroll');

    return () => {
      document.body.classList.remove('email-migration-lock-scroll');
    };
  }, [shouldShowEmailMigrationBanner, shouldShowEmailAlreadyCompletedBanner, location.pathname]);

  useEffect(() => {
    if (completed === undefined) {
      dispatch(fetchNarratives());
    }
  }, [dispatch, completed]);

  useEffect(() => {
    if (!loading && !dataFetched) {
      setDataFetched(true);
    }
  }, [loading, dataFetched]);

  useEffect(() => {
    if (dataFetched) {
      const shouldExclude = excludedPaths.some((path) => matchPath(location.pathname, path));

      if (!shouldExclude) {
        if (error) {
          if (errorTimeout) {
            clearTimeout(errorTimeout);
          }

          const timer = setTimeout(() => {
            if (error === 'You have not completed mandatory Tech Central Training, please complete it.') {
              setShowDCModal(true);
              dispatch(setTrainingStatus(false));
              dispatch(setTrainingSuccess(false)); // Reset success state
            }
          }, 1000); // Delay in milliseconds (e.g., 3000ms = 3 seconds)

          setErrorTimeout(timer);
        } else {
          setShowDCModal(false);
          if (success) {
            dispatch(setTrainingStatus(true));
          }
        }
      } else {
        setShowDCModal(false);
      }
    }
  }, [dataFetched, loading, error, location.pathname, dispatch, success]);


  const [isDisclaimerVisible, setIsDisclaimerVisible] = useState(false);
  const [disclaimerData, setDisclaimerData] = useState(null);





  useEffect(() => {
    // Fetch disclaimer on mount


    if (currentUser?.typeOfUser === 'External SE') {
    dispatch(getPartnerDisclaimerAct())
      .then((response) => {
        if (response.success) {
          setDisclaimerData({
            title: response["disclaimer-title"],
            message: response["disclaimer-message"],
          });
          setIsDisclaimerVisible(true); // Show disclaimer
          localStorage.setItem("IsDisclaimerAccepted", "false");
        } else if (response.error === "You have already accepted the disclaimer terms.") {
          setIsDisclaimerVisible(false); // Hide disclaimer if already accepted
          localStorage.setItem("IsDisclaimerAccepted", "true");
        } else {
          console.error("Unexpected API response:", response.error);

        }
      })
      .catch(() => {
        console.error("Failed to fetch disclaimer.");
        localStorage.setItem("IsDisclaimerAccepted", "true");
      });
    }
  }, [dispatch]);

  const handleDisclaimerAccept = () => {
    setIsDisclaimerVisible(false); // Hide disclaimer after acceptance
    localStorage.setItem("IsDisclaimerAccepted", "true");
    window.location.reload(); // Reload the page to apply changes
  };



  useEffect(() => {
    if (isDisclaimerVisible) {
      document.body.classList.add("disclaimer-active"); // Add a specific class
    } else {
      document.body.classList.remove("disclaimer-active"); // Remove it when hidden
    }

    // Cleanup on unmount
    return () => {
      document.body.classList.remove("disclaimer-active");
    };
  }, [isDisclaimerVisible]);

  if (isEmailMigrationRoute) {
    return (
      <SnackbarProvider maxSnack={3} anchorOrigin={{ vertical: 'top', horizontal: 'right', }}>
        <div className="private-layout-email-migration-mode">
          {children}
        </div>
      </SnackbarProvider>
    );
  }

  if (currentUser?.typeOfUser === "Sales") {
    return (
      <SnackbarProvider maxSnack={3} anchorOrigin={{ vertical: 'top', horizontal: 'right', }}>
        {(shouldShowEmailMigrationBanner || shouldShowEmailAlreadyCompletedBanner) && (
          <>
            <div className="email-migration-page-overlay" />
            <EmailMigrationBanner
              mode={shouldShowEmailAlreadyCompletedBanner ? 'alreadyCompleted' : 'updateRequired'}
              onUpdateNow={handleEmailMigrationUpdateNow}
              onLogoutNow={handleEmailMigrationLogoutNow}
            />
          </>
        )}
        <div className="page-container">
          <div className="main-content">
            {children}
          </div>
          {!isHomeOrSalesRoute && !isChangePasswordRoute && <FooterBlock />} {/* Show footer ONLY if NOT on /home or /sales/:id */}
        </div>
         <FloatingOptions /> 
      </SnackbarProvider>
    );
  }




  return (
    <>
      <SnackbarProvider maxSnack={3} anchorOrigin={{ vertical: 'top', horizontal: 'right', }}>
        {(shouldShowEmailMigrationBanner || shouldShowEmailAlreadyCompletedBanner) && (
          <>
            <div className="email-migration-page-overlay" />
            <EmailMigrationBanner
              mode={shouldShowEmailAlreadyCompletedBanner ? 'alreadyCompleted' : 'updateRequired'}
              onUpdateNow={handleEmailMigrationUpdateNow}
              onLogoutNow={handleEmailMigrationLogoutNow}
            />
          </>
        )}

        {/* Interaction Blocker */}
        {isDisclaimerVisible && <div className="interaction-blocker" />}

        <div className={`content desc-tech ${isDisclaimerVisible ? "blurred" : "clear"}`}>

          <div className="page-container">
            {!isSalesRoute && !isChangePasswordRoute &&<Marquee />} {/* Hide Marquee on /sales/:id routes */}

            <div className="main-content">
              {children}
            </div>

            {!isSalesRoute && !isChangePasswordRoute &&<FooterBlock />} {/* Hide Footer on /sales/:id routes */}
          </div>

        </div>

        <Modal
          {...props}
          size="lg"
          aria-labelledby="contained-modal-title-vcenter"
          centered
          backdrop="static"
          style={{ backgroundColor: 'rgba(0, 0, 0, 0.8)' }}
          show={showDCModal}
          fullscreen={false}
        >
          <Modal.Body className='dc-modal'>
            <div className="d-flex flex-column flex-md-row">
              <div className="order-2 order-md-1 mr-md-3 mb-3 mb-md-0 d-none d-md-block">
                <img src={DC_img} alt="Tech Central training" className="img-fluid" style={{ maxHeight: '100%', maxWidth: '100%' }} />
              </div>
              <div className="order-1 order-md-2">
                <div className='dc-modal-content'>
                  <p className='dc-modal-hello-ser'>Hello {currentUser?.firstname ? currentUser?.firstname : 'User'}!</p>
                  <h1 className='dc-modal-heading'>We invite you to complete the essential <span className='dc-modal-heading-orange'>Tech Central<br></br> training</span></h1>
                  <p className='dc-modal-desc'>We're thrilled to enhance your Tech Central experience! Before you dive into exciting new narratives</p>
                  {shouldShowEnablementNav && (
                    <Link to={`${PATH.LEARNING_HUB_PATH}`}><button className='dc-modal-visit'>Visit Learning Hub</button></Link>
                  )}
                  <p className='dc-modal-note'>* To access the Tech Central portal, you must undergo this training.</p>
                </div>
              </div>
            </div>
          </Modal.Body>
        </Modal>



        
        {/* Disclaimer Component */}
        {isDisclaimerVisible && (
          <Disclaimer
            disclaimerData={disclaimerData}
            onAccept={handleDisclaimerAccept}
          />
        )}
        {!isChangePasswordRoute && <FloatingOptions />}
      </SnackbarProvider>
    </>
  );
};

export default PrivateLayout;
